const getters = {
  pet: state => state.addReserveInfo.pet,
  petHospital: state => state.addReserveInfo.petHospital,
  vaccineInfo: state => state.addReserveInfo.vaccineInfo,
  recordDate: state => state.addReserveInfo.recordDate,
  petInfo: state => state.myPet.petInfo,
  petBreed: state => state.myPet.petBreed,
}
export default getters
